import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Button,
  Drawer,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Box,
  Typography,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

const Navbar = ({ onLogout, isLoggedIn, onOpenRules, onOpenLeaderboard, onOpenAccount, isInGame }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <>

  <IconButton
    edge="end"
    color="inherit"
    onClick={toggleMenu}
    sx={{
         pointerEvents: "auto", // ✅ DŮLEŽITÉ: vrátí klikání tlačítku
      position: "absolute", // ✅ není fixed → odscrolluje pryč
      zIndex: 3000, // ✅ nad vším ostatním
      top: 12,
      right: { xs: 12, md: "max(12px, calc(50% - 320px))" },
      backgroundColor: "transparent",
      border: "none",
      boxShadow: "none",
      display: "inline-flex",
      "&:hover": { backgroundColor: "transparent" },
    }}
  >
    <MenuIcon sx={{ fontSize: 32 }} />
  </IconButton>


      {/* 📱 Mobilní menu - upravený styl (beze změn) */}
      <Drawer
        anchor="right"
        open={menuOpen}
        onClose={toggleMenu}
        PaperProps={{
          sx: {
            backgroundColor: "black",
            color: "white",
            width: 250,
          },
        }}
      >
        <List>
          <ListItem button component="a" href="https://www.breakthemystery.cz" target="_blank" onClick={toggleMenu}>
            <ListItemText
              primary={
                <Typography sx={{ fontFamily: "'Cinzel', serif", textTransform: "uppercase", fontSize: "16px" }}>
                  E-shop
                </Typography>
              }
            />
          </ListItem>

          <ListItem
            button
            onClick={() => {
              onOpenRules();
              toggleMenu();
            }}
          >
            <ListItemText
              primary={
                <Typography sx={{ fontFamily: "'Cinzel', serif", textTransform: "uppercase", fontSize: "16px" }}>
                  Pravidla
                </Typography>
              }
            />
          </ListItem>

          <ListItem
            button
            onClick={() => {
              onOpenLeaderboard();
              toggleMenu();
            }}
          >
            <ListItemText
              primary={
                <Typography sx={{ fontFamily: "'Cinzel', serif", textTransform: "uppercase", fontSize: "16px" }}>
                  LeaderBoard
                </Typography>
              }
            />
          </ListItem>

          {isLoggedIn && (
            <ListItem
              button
              onClick={() => {
                onOpenAccount();
                toggleMenu();
              }}
            >
              <ListItemText
                primary={
                  <Typography sx={{ fontFamily: "'Cinzel', serif", textTransform: "uppercase", fontSize: "16px" }}>
                    Můj účet
                  </Typography>
                }
              />
            </ListItem>
          )}
        </List>
      </Drawer>
    </>
  );
};

export default Navbar;